import React from "react";
import LogoAnimation from "../logoanimation/LogoAnimation";
import { connect } from "react-redux";

import ScrollArrow from "../scrollarrow/ScrollArrow";

class DataLoader extends React.Component {
  constructor() {
    super();

    let serverURL;

    //serverURL = "https://kastner.agency/wp/";

    serverURL = "http://kastner-global.local/";

    if (process.env.NODE_ENV === "production") {
      serverURL = "/wp/";
    }

    this.state = {
      serverURL,
      loaded: false,
      pageNumber: 1,
      loadCount: 0,

      // set to false to show the logo animtion
      //animationFinished: true
    };

    this.loadWork = this.loadWork.bind(this);
    this.workDataLoaded = this.workDataLoaded.bind(this);
    this.setAnimationFinished = this.setAnimationFinished.bind(this);
  }

  loadWork() {
    let url =
      this.state.serverURL +
      "wp-json/wp/v2/work?per_page=100&page=" +
      this.state.pageNumber;

    fetch(url)
      .then((results) => results.json())
      .then((array) => {
        this.workDataLoaded(array);
      });
  }

  workDataLoaded(array) {
    if (array.length) {
      this.props.setWorkData(array);
      if (this.props.loadAll !== "true") {
        this.setState({ loaded: true });
      }
    } else {
      if (this.props.loadAll === "true") {
        this.setState({ loaded: true });
      }
      console.log("All Work Loaded");

      let loadCount = this.state.loadCount + 1;
      this.setState({ loadCount });
    }

    if (array.length) {
      if (array.length === 100) {
        let pageNumber = this.state.pageNumber + 1;
        this.setState({ pageNumber });
        this.loadFilms();
      } else {
        this.setState({ loaded: true });
        let loadCount = this.state.loadCount + 1;
        this.setState({ loadCount });
        console.log(
          "Work payload less than 100, All Work loaded",
          this.state.loaded
        );
      }
    }
  }

  loadOptionsPage() {
    let url = this.state.serverURL + "wp-json/acf/v2/options/";
    fetch(url)
      .then((results) => results.json())
      .then((array) => {
        this.optionsPageDataLoaded(array);
      });
  }
  optionsPageDataLoaded(array) {
    this.props.setOptionsPageData(array);
    this.setState({ loaded: true });

    let loadCount = this.state.loadCount + 1;
    this.setState({ loadCount });
  }

  loadPages() {
    let url = this.state.serverURL + "wp-json/wp/v2/pages";
    fetch(url)
      .then((results) => results.json())
      .then((array) => {
        this.pagesDataLoaded(array);
      });
  }
  pagesDataLoaded(array) {
    this.props.setPagesData(array);
    this.setState({ loaded: true });

    let loadCount = this.state.loadCount + 1;
    this.setState({ loadCount });
  }

  loadOffices() {
    let url = this.state.serverURL + "wp-json/wp/v2/offices";
    fetch(url)
      .then((results) => results.json())
      .then((array) => {
        this.officesDataLoaded(array);
      });
  }
  officesDataLoaded(array) {
    this.props.setOfficesData(array);
    this.setState({ loaded: true });

    let loadCount = this.state.loadCount + 1;
    this.setState({ loadCount });
  }

  loadClients() {
    let url = this.state.serverURL + "wp-json/wp/v2/client?per_page=100";
    fetch(url)
      .then((results) => results.json())
      .then((array) => {
        this.clientsDataLoaded(array);
      });
  }
  clientsDataLoaded(array) {
    this.props.setClientsData(array);
    this.setState({ loaded: true });

    let loadCount = this.state.loadCount + 1;
    this.setState({ loadCount });
  }

  //http://kastner:8888/wp-json/wp/v2/careers

  loadCareers() {
    let url = this.state.serverURL + "wp-json/wp/v2/careers?per_page=100";
    fetch(url)
      .then((results) => results.json())
      .then((array) => {
        this.careersDataLoaded(array);
      });
  }
  careersDataLoaded(array) {
    this.props.setCareersData(array);
    this.setState({ loaded: true });

    let loadCount = this.state.loadCount + 1;
    this.setState({ loadCount });
  }

  loadNews() {
    let url = this.state.serverURL + "wp-json/wp/v2/news?per_page=100";
    fetch(url)
      .then((results) => results.json())
      .then((array) => {
        this.newsDataLoaded(array);
      });
  }
  newsDataLoaded(array) {
    this.props.setNewsData(array);
    this.setState({ loaded: true });

    let loadCount = this.state.loadCount + 1;
    this.setState({ loadCount });
  }

  componentWillMount() {
    this.props.workData ? this.setState({ loaded: true }) : this.loadWork();

    // This is loading the options page

    this.props.optionsData
      ? this.setState({ loaded: true })
      : this.loadOptionsPage();

    this.props.pagesData ? this.setState({ loaded: true }) : this.loadPages();

    this.props.officesData
      ? this.setState({ loaded: true })
      : this.loadOffices();

    this.props.clientsData
      ? this.setState({ loaded: true })
      : this.loadClients();

    this.props.careersData
      ? this.setState({ loaded: true })
      : this.loadCareers();

    this.props.newsData ? this.setState({ loaded: true }) : this.loadNews();
  }

  componentWillUpdate() {}

  setAnimationFinished() {
    this.setState({ animationFinished: true });
  }

  render() {
    return (
      <div>
        {this.state.loadCount === 7 && this.state.animationFinished ? (
          this.props.children
        ) : (
          <div className="loading-screen">
            <div className="loading-animation">
              <LogoAnimation
                callBack={this.setAnimationFinished}
                dataLoaded={this.state.loadCount === 7}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const workData = state.workData;
  const optionsData = state.optionsData;
  const pagesData = state.pagesData;
  const careersData = state.careersData;
  const newsData = state.newsData;

  return {
    workData,
    optionsData,
    pagesData,
    careersData,
    newsData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setWorkData: (data) => {
      //console.log('ScrollIndex',index,max,dir)
      dispatch({ type: "ADD_WORK_DATA", payload: data });
    },

    setOptionsPageData: (data) => {
      //console.log('ScrollIndex',index,max,dir)
      dispatch({ type: "ADD_OPTIONS_DATA", payload: data });
    },
    setPagesData: (data) => {
      //console.log('ScrollIndex',index,max,dir)
      dispatch({ type: "ADD_PAGES_DATA", payload: data });
    },
    setOfficesData: (data) => {
      //console.log('ScrollIndex',index,max,dir)
      dispatch({ type: "ADD_OFFICES_DATA", payload: data });
    },
    setClientsData: (data) => {
      //console.log('ScrollIndex',index,max,dir)
      dispatch({ type: "ADD_CLIENTS_DATA", payload: data });
    },
    setCareersData: (data) => {
      //console.log('ScrollIndex',index,max,dir)
      dispatch({ type: "ADD_CAREERS_DATA", payload: data });
    },
    setNewsData: (data) => {
      //console.log('ScrollIndex',index,max,dir)
      dispatch({ type: "ADD_NEWS_DATA", payload: data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataLoader);



// WEBPACK FOOTER //
// ./src/modules/data/DataLoader.js